<template>
  <div class="">
    <div v-if="!edit" class="applied-jobs">
      <div class="row">
        <div class="input-group">
          <input
                  v-model="company_filter"
                  class="form-control"
                  placeholder="Search Company"
                  type="text"
          />
          <div class="input-group-append">
                      <span
                              @click="company_filter = ''"
                              class="input-group-text"
                      >clear</span
                      >
          </div>
        </div>
      </div>
      <div v-if="!noData && jobs.length > 0" class="row search-results">
        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 list-result">
          <div class="job-list-wrapper">
            <div class="header-text">
              <div class="row justify-content-between">
                <div class="col-6">
                  <div class="ttl">Pending Approval</div>
                  <div class="sub-ttl">Showing {{ jobs.length }} jobs</div>
                </div>
              </div>
            </div>
            <div style="height: 100%" class="row" v-if="loading">
              <div class="my-auto mx-auto">
                <v-progress-circular
                  :size="70"
                  :width="3"
                  color="primary"
                  indeterminate
                ></v-progress-circular>
              </div>
            </div>
            <div class="row job-list" :key="changeJob">
              <div
                @click="viewThisJob(job, index)"
                v-bind:class="{ activeJob: isActive(index) }"
                class="job"
                :key="index"
                v-for="(job, index) in jobs"
              >
                <job-synopsis v-bind:job="job"> </job-synopsis>
              </div>
            </div>
          </div>
          <div v-if="load_more" class="pagination-wrapper">
            <div class="pagination">
              <div @click="pagination" class="load-more">Load more</div>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8 job-preview-wrapper">
          <div :key="changeView" class="job-preview">
            <job-details
              v-bind:compliance="currentJob.compliance"
              v-bind:job="currentJob"
              v-bind:index="currentIndex"
              v-on:change-status="changeJobStatus"
              v-on:edit-job="editThisJob"
            ></job-details>
          </div>
        </div>
      </div>
      <div v-if="noData && errMsg" class="row no-result no-padding">
        <div class="mx-auto my-auto">
          <img
            class="no-result-image"
            src="@/assets/newDesign/no-approved-job.svg"
          />
          <div class="no-result-color">
            <b>Sorry {{ errMsg }}</b>
          </div>
        </div>
      </div>
      <v-snackbar :color="bgColor" :timeout="timeOut" top v-model="snackbar">
        <div style="text-align: center; width: 100%">
          <span style="padding-right:1.0rem"
            ><v-icon color="#fff">{{ snackIcon }}</v-icon></span
          >{{ snackMessage }}
        </div>
        <!--<v-btn flat :ripple="ripple" @click="snackbar = false">-->
        <!--<v-icon>close</v-icon>-->
        <!--</v-btn>-->
      </v-snackbar>
    </div>
    <div v-if="edit">
      <edit-job
        v-bind:from="'pending'"
        v-bind:job="editableJobObj"
        v-on:cancel-job-posting="cancelPosting"
      ></edit-job>
    </div>
  </div>
</template>

<script>
import JobSynopsis from "./job-synopsis";
import JobDetails from "./job-details";
import EditJob from "../../employer/post-a-job/post-a-job-form";
import { CHANGE_JOB_STATUS, GET_JOBS_ADMIN } from "../../../Api/admin_api";
export default {
  name: "pending-jobs",
  components: {
    JobDetails,
    JobSynopsis,
    EditJob
  },
  data: function() {
    return {
      jobs: [],
      all_jobs: [],
      noData: false,
      bgColor: "#454545",
      timeOut: 2000,
      snackbar: false,
      snackIcon: "",
      snackMessage: "",
      ripple: false,
      changeView: 0,
      changeJob: 0,
      load_more: false,
      loading: false,
      currentJob: {},
      currentIndex: 0,
      errMsg: "",
      last_evaluated_key: null,
      edit: false,
      editableJobObj: {},
      company_filter: "",
      timeout: null
    };
  },
  methods: {
    changeJobStatus(job_id, action) {
      const self = this;
      let params = {
        job_ids: [job_id],
        action: action,
        job_status: "pending"
      };
      CHANGE_JOB_STATUS(params)
        .then(function(response) {
          self.snackbar = true;
          self.snackIcon = self.$constants.SNACKBAR_ICON.SUCCESS;
          self.bgColor = self.$constants.SNACKBAR_COLOR.SUCCESS;
          self.snackMessage = response.message;
          self.timeout = setTimeout(function() {
            self.getPendingJobs();
          }, 2000);
        })
        .catch(function(err) {
          self.snackbar = true;
          self.snackIcon = self.$constants.SNACKBAR_ICON.ERROR;
          self.bgColor = self.$constants.SNACKBAR_COLOR.ERROR;
          self.snackMessage = err.message;
        });
    },
    getPendingJobs: function() {
      const self = this;
      if (!self.last_evaluated_key) {
        self.jobs = [];
        self.all_jobs = [];
      }
      let params = {
        status: "pending",
        last_evaluated_key: self.last_evaluated_key
      };
      GET_JOBS_ADMIN(params)
        .then(function(data) {
          let i;
          for (i = 0; i < data.jobs.length; i++) {
            self.jobs.push(data.jobs[i]);
            self.all_jobs.push(data.jobs[i]);
          }
          self.currentIndex = 0;
          self.currentJob = data.jobs[self.currentIndex];
          self.changeView++;
          if (data.last_evaluated_key) {
            self.last_evaluated_key = data.last_evaluated_key;
            self.load_more = true;
          } else {
            self.last_evaluated_key = null;
            self.load_more = false;
          }
          if (self.jobs.length === 0) {
            self.noData = true;
          }
        })
        .catch(function(err) {
          self.noData = true;
          self.errMsg = err.message;
        });
    },
    viewThisJob: function(job, index) {
      const self = this;
      self.currentIndex = index;
      self.currentJob = job;
      self.changeView++;
    },
    isActive(index) {
      return this.currentIndex === index;
    },
    pagination: function() {
      this.getPendingJobs();
    },
    editThisJob(job) {
      const self = this;
      self.editableJobObj = job;
      self.edit = true;
    },
    cancelPosting() {
      const self = this;
      self.edit = false;
    }
  },
  watch: {
    company_filter(newV, oldV) {
      if (newV.toUpperCase() !== oldV.toUpperCase()) {
        let i;
        this.jobs = [];
        for (i = 0; i < this.all_jobs.length; i++) {
          if (
            this.all_jobs[i].company_name
              .toUpperCase()
              .includes(newV.toUpperCase())
          ) {
            this.jobs.push(this.all_jobs[i]);
          }
        }
        this.changeJob++;
      }
    }
  },
  beforeDestroy(){
    clearTimeout(this.timeout)
  },
  mounted() {
    this.getPendingJobs();
  }
};
</script>

<style scoped>
.applied-jobs {
  height: 90vh;
  margin: 0 1rem 1rem;
}
.prog {
  margin: 0;
}
.no-result {
  margin: 2.5rem !important;
  height: 80vh;
  box-shadow: 0 0 0.2rem 0 rgba(0, 0, 0, 0.16);
}
.no-result-color {
  margin-top: 1rem;
  font-size: 2.4rem;
  color: var(--button-delete-color);
}
.no-result-image {
  width: 30rem;
}
.list-result {
  margin-top: 1rem;
  padding: 0;
  border-radius: 0.8rem;
  box-shadow: 0 0 0.2rem 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
}
.header-text {
  background-color: #fafafa;
  padding: 1.5rem;
  position: absolute;
  top: 0;
  z-index: 2;
  width: 100%;
  text-align: left;
}
.ttl {
  font-size: 2rem;
  font-weight: bold;
  line-height: 1.25;
  color: #050405;
}
.sub-ttl {
  font-size: 1.4rem;
  line-height: 1.25;
  text-align: left;
  color: rgba(5, 5, 5, 0.6);
}
.job-list-wrapper {
  padding: 7rem 0 3rem 0;
  /*background-color: #ffffff;*/
  height: 90vh;
  overflow: scroll;
}
.job-list {
  background-color: #ffffff;
}
.job {
  width: 100%;
}
.job-preview-wrapper {
  height: 90vh;
  padding: 0 0 0 3.2rem;
}
.job-preview {
  margin: 1rem 0;
  height: 100%;
  border-radius: 0.8rem;
  box-shadow: 0 0 0.2rem 0 rgba(0, 0, 0, 0.16);
}
.pagination-wrapper {
  width: 100%;
  position: absolute;
  bottom: 0;
  padding: 1rem 0 2rem 0;
  border-radius: 0.8rem 0;
  background-color: #ffffff;
}
.pagination {
  display: flex;
  justify-content: center;
}
.load-more {
  background-color: var(--button-color);
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  cursor: pointer;
  color: white;
}
.form-control {
  border: 0.1rem solid #e0dbdb;
  background-color: white;
  font-size: 1.4rem;
  border-radius: 0.4rem;
  border-right: none;
}
.form-control:focus {
  box-shadow: none !important;
}
@media (max-width: 600px) {
  .job-list-wrapper {
    height: auto;
  }
}
</style>
